import request from "@/utils/request.js";

/*** 校验登录**/
export function checkLogin(data) {
	return request.post('nsh/login', data, {
		noAuth: true
	});
}
/**获取支付**/
export function toPay(order_id) {
	return request.post('nsh/trade/pay', {
		order_id
	})
}
/**支付确认**/
export function confirmOrderPay(SignValue, Request) {
	return request.post('nsh/trade/confirmpay', {
		SignValue,
		Request
	})
}
/**支付明细**/
export function getPayDetails(groupOrderId) {
	return request.post('nsh/trade/paydetails', {
		group_order_id:groupOrderId
	})
}
/**退款明细**/
 export function getRefundDetails(refundOrderSn){
	 return request.post('nsh/trade/refunddetails',{
		 out_refund_no:refundOrderSn
	 })
 }
 
 /**
  * 判断是否是老用户
  */
 export function isOldCheck(){
 	return request.get('nsh/trade/old_check');
 }
 
 /**
  * 券码兑换
  */
 export function submitCouponExchange(coupon_pass){
	 return request.post('coupon/exchange',{
		 coupon_pass
	 })
 }